import { withLandingFilterStore } from '@doltech/ui/lib/figma/LandingFilterV2/withLandingFilterStore';
import { compose } from '@doltech/utils/lib/compose';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { getSpeakingLandingFilter } from '../../constants';
import { SpeakingSampleCard } from '../components/SpeakingSampleCard';
import {
  SampleTypeLandingTemplate,
  SampleTypeLandingTemplateProps,
} from '../templates/SampleTypeLandingTemplate';
import { SpeakingSampleTypeEnum } from '@doltech/utils/lib/constants';

interface SpeakingSamplePartLandingContentProps extends SampleTypeLandingTemplateProps {}

const SpeakingSamplePartLandingContent = (props: SpeakingSamplePartLandingContentProps) => {
  return (
    <SampleTypeLandingTemplate
      renderCard={(cardData) => {
        return <SpeakingSampleCard data={cardData} />;
      }}
      {...props}
    />
  );
};

const withSampleFilter = (Component) => (props) => {
  const { pageData } = props;
  const { type } = pageData || {};
  switch (type) {
    case SpeakingSampleTypeEnum.SPEAKING_PART_1:
    case SpeakingSampleTypeEnum.SPEAKING_PART_2:
    case SpeakingSampleTypeEnum.SPEAKING_PART_3: {
      return withLandingFilterStore(getSpeakingLandingFilter(type), {
        syncUrl: false,
      })(Component)(props);
    }
    default:
      throw new Error(`Expected speaking sample type only, not ${type}`);
  }
  // return <Component {...props} />;
};

export const SpeakingSamplePartLanding: React.FunctionComponent<SpeakingSamplePartLandingContentProps> =
  compose(withSampleFilter, observer)(SpeakingSamplePartLandingContent);
